import * as PIXI from 'pixi.js';
import { APP_WIDTH, APP_HEIGHT } from '../../features/utils';

export default class SpriteSheetDemoManager {
    constructor() {
        this.container = new PIXI.Container();
        this.container.label = 'spriteSheetDemoContainer';
        this.animationSpeed = 1;
    }

    attachToPixiApp(app) {
        app.stage.addChild(this.container);
    }

    detachFromPixiApp(app) {
        app.renderer.background.color = 'black';
        app.stage.removeChild(this.container);
    }

    setAnimationSpeed(speed) {
        this.animationSpeed = speed;
        if (this.animatedSprite) {
            this.animatedSprite.animationSpeed = speed;
        }
    }

    async setSpriteSheet(blobUrl) {
        this.container.removeChildren();
        
        const texture = await PIXI.Assets.load({ src: blobUrl, format: 'png', loadParser: 'loadTextures' });
        this.texture = texture;
        const sprite = new PIXI.Sprite(texture);
        sprite.label = 'spriteSheetSprite';
        sprite.x = APP_WIDTH / 2;
        sprite.y = APP_HEIGHT / 2;
        sprite.anchor.set(0.5);
        this.container.addChild(sprite);
    }

    async setAnimationJson(blobUrl) {
        if (!this.texture) return;

        const animationJson = await PIXI.Assets.load({ src: blobUrl, loadParser: 'loadJson' });
        const spritesheet = new PIXI.Spritesheet(this.texture, animationJson);
        await spritesheet.parse();
        
        this.container.removeChildren();
        
        const animatedSprite = new PIXI.AnimatedSprite(Object.values(spritesheet.textures));
        animatedSprite.animationSpeed = this.animationSpeed;
        animatedSprite.label = 'animatedSprite';
        animatedSprite.x = APP_WIDTH / 2;
        animatedSprite.y = APP_HEIGHT / 2;
        animatedSprite.anchor.set(0.5);
        animatedSprite.play();
        this.container.addChild(animatedSprite);
        this.animatedSprite = animatedSprite;
        // const animation = new PIXI.Animation(animationJson);
        // this.container.addChild(animation);
    }
}